import { z } from "zod";

export const setupSchema = z.object({
  currency: z.enum(["GEL", "USD", "EUR", "GBP"]),
  limit: z.string()
    .trim()
    .regex(/^\d+(?:\.\d{1,2})?$/, "Use a positive amount with up to two decimal places.")
    .refine((value) => Number(value) > 0, "The monthly budget must be greater than zero."),
});

export type SetupForm = z.infer<typeof setupSchema>;
